import React from "react";

function XCard({ title, children, footer, shadow }) {
  return (
    <div className={`card ${shadow === "none" ? "" : "shadow"} mb-4`}>
      {title ? (
        <div className="card-header">
          <h5 className="text-primary">{title}</h5>
        </div>
      ) : null}
      <div className="card-body">{children}</div>
      {footer ? <div className="card-footer">{footer}</div> : null}
    </div>
  );
}

export default XCard;
